const LOGO_ICON = "https://customer-assets.emergentagent.com/job_3d59354d-0972-4474-8092-a9560caa3a16/artifacts/salc548w_2.jpg";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#050508] border-t border-[rgba(163,168,216,0.08)] px-6 md:px-12 lg:px-20 py-12"
        >
            <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <div className="logo-frame w-9 h-9 rounded-sm overflow-hidden">
                        <img
                            src={LOGO_ICON}
                            alt="Stout Road"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <span className="font-heading text-lg text-white tracking-wide">
                        Stout Road
                    </span>
                </div>

                <div className="flex flex-wrap items-center gap-x-8 gap-y-2 text-white/40 text-xs uppercase tracking-[0.2em]">
                    <span data-testid="footer-tagline">
                        Fractional & Interim CFO Services
                    </span>
                    <span className="hidden md:inline">·</span>
                    <span data-testid="footer-domain">StoutRoad.com</span>
                </div>

                <p
                    data-testid="footer-copyright"
                    className="text-white/35 text-xs"
                >
                    © {year} Stout Road. All rights reserved.
                </p>
            </div>
        </footer>
    );
}
